import React from "react";

import { Flex, Spinner } from "@chakra-ui/react";

const ProspectSkeletons = () => {
  return (
    <Flex width={"100%"} h="75%" alignItems="center" justifyContent="center">
      <Spinner size="xl" />
    </Flex>
  );
};

export default ProspectSkeletons;
